const objectKeys = ['object_type', 'object_id', 'image_set', 'image_type'];

const searchKeys = ['search_id', 'search_version'];

const keysToClearByEvent = new Map<string, string[]>([
  ['component', objectKeys],
  ['system', objectKeys],
  ['search', searchKeys],
]);

/**
 * GTM keeps every dataLayer key until a later push overwrites it, and the GTM
 * tags of these events read the keys below. Such an event that does not
 * describe an object would otherwise inherit the object of an earlier
 * event, e.g. checkout_start carrying the product of a gallery swipe, or a
 * search suggest event carrying the search_id of the previous submit.
 */
export const withClearedObjectKeys = <T extends object>(event: T): T => {
  if (!('event' in event)) {
    return event;
  }

  const keys = keysToClearByEvent.get(event.event as string);

  if (!keys) {
    return event;
  }

  return {
    ...Object.fromEntries(keys.map(key => [key, undefined])),
    ...event,
  };
};
